import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { finalize } from 'rxjs/operators';
import { LoginRequest } from 'src/app/models/login.model';
import { AlertService } from 'src/app/service/alert.service';
import { CannonicalService } from 'src/app/service/cannonical.service';
import { AuthenticationService } from 'src/app/service/http-services/authentication.service';
import { UserService } from 'src/app/service/http-services/user.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  form: FormGroup
  loadingLogin: boolean = false;
  routeToMobile = true;

  constructor(
    public fb: FormBuilder,
    private router: Router,
    private loginService: AuthenticationService,
    private userService: UserService,
    private alertService: AlertService,
    private cannonicalService: CannonicalService,
    private activatedRoute: ActivatedRoute) {
    this.form = fb.group({
      emailFormEx: [null, [Validators.required, Validators.email]],
      password: [null, [Validators.required]]
    })
  }

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe(params => {
      let mailParam = params["mailActivation"];
      if (mailParam === 'true') {
        this.alertService.success("Email verified succesfully")
      }
      else if (mailParam === "alreadyVerified") {
        this.alertService.warn("Email already verified")
      }
    })
    this.routeToMobile = navigator.userAgent.toLowerCase().indexOf("android") > -1;
  }

  get loginForm() { return this.form.controls; }

  doLogin() {
    let loginReq: LoginRequest = {
      username: this.loginForm.emailFormEx.value,
      password: this.loginForm.password.value
    }
    this.loadingLogin = true;
    this.loginService.authenticate(loginReq).pipe(
      finalize(() => this.loadingLogin = false)
    )
      .subscribe(
        rsp => {
          if (rsp.body === null) {
            this.alertService.error("Something went wrong - try again later")
          }
          else {
            let token = rsp.body.replace(loginReq.username + " ", "");
            localStorage.setItem("token", token);
            this.userService.getUserByHttp().subscribe(user => {
              this.userService.saveUserStorage(user);
              if (user.initialSetup) {
                this.router.navigate(['/chat'])
              }
              else {
                this.router.navigate(["/setup"])
              }
            })
          }
        },
        err => {
          this.form.controls.password.reset();
          this.alertService.error(err.error)
        }
      )
  }

  routeToMobileApp() {
    let app = {
      launchApp: function () {
        window.location.replace("getbetterio://launch");
        setTimeout(this.openWebApp, 500);
      },
      openWebApp: function () {
        window.location.href = "https://play.google.com/store/apps/details?id=com.getbetter_io";
      }
    }
    app.launchApp();
  };

  get emailFormEx() { return this.form.get('emailFormEx'); }
}


